// Query keys for ring fence hooks to avoid circular dependencies
export const GetRingFenceKey = "RingFence";
export const GetRingFencesByScenarioKey = "RingFencesByScenario";
export const GetAllRingFencesKey = "AllRingFences";
